import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["event"];
/* eslint-disable react/prop-types */
import React from 'react';
import Event from './Event';
export default function withEvent(eventType) {
  return function (WrappedComponent) {
    return function (props) {
      var event = props.event,
        restProps = _objectWithoutProperties(props, _excluded);
      if (!event) {
        return /*#__PURE__*/React.createElement(WrappedComponent, props);
      }
      return /*#__PURE__*/React.createElement(Event, {
        event: event,
        eventType: eventType
      }, /*#__PURE__*/React.createElement(WrappedComponent, restProps));
    };
  };
}